import { defineStore } from 'pinia'

interface State {
  isChargingBatteries: boolean
}

const useLoading = defineStore({
  id: 'loadingStore',
  state: (): State => ({
    isChargingBatteries: false,
  }),
  actions: {
    setLoadingState() {
      this.isChargingBatteries = true
    },
    dismissLoadingState() {
      this.isChargingBatteries = false
    },
  },
})

export default useLoading
